import { Message } from 'element-ui'
export default {
    toLogin(state, br){
        state.isLogin = br;
    },
    showLogin(state, br){
        state.loginShow = br;
    },
    changeUserImg(state, src){
        state.userImage = src;
    },
    changeCdjsID(state, id){
        state.cdjsID = id;
    },
    changeCdCode(state, str){
        state.cdCode = str;
    },
    changePoints(state, id){
        state.pointsDetailId = id;
    },
    changeShowLabels(state, br){
        state.showLabels = br;
    },
    changeRefreshLabels(state){
        state.refreshLabels ++
    },
    reduce(state){
        state.count--;
    },
    afterEach (to, from, next) {
        window.scrollTo(0, 0)
    },
    startComputeCurrent(state) {
        state.intervalID = setInterval(() => {
          state.current = Date.now()
        }, 500)
      },
      stopComputeCurrent(state) {
        clearInterval(state.intervalID)
        state.intervalID = 0
      },
      showMessage(state, options) {
        if (state.message) {
          state.message.close()
        }
        state.message = Message({
          message: options.message,
          type: options.type || 'success',
          duration: options.duration || 2000,
          offset: 40
        })
      }
}



// WEBPACK FOOTER //
// ./src/vuex/mutations.js